import { render, staticRenderFns } from "./GameTakePicture.vue?vue&type=template&id=ed310316&scoped=true"
import script from "./GameTakePicture.vue?vue&type=script&lang=js"
export * from "./GameTakePicture.vue?vue&type=script&lang=js"
import style0 from "./GameTakePicture.vue?vue&type=style&index=0&id=ed310316&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed310316",
  null
  
)

export default component.exports